import PropTypes from 'prop-types';
import { noop } from 'src/utils/core/event';
import CapActionResourceModel from 'src/components/CapActionResource/CapActionResourceModel.class';

export const CapActionResourcePropTypes = {
  action: PropTypes.object,
  allExternalUsersId: PropTypes.arrayOf(PropTypes.number),
  currencies: PropTypes.array,
  index: PropTypes.number,
  isActionEditable: PropTypes.bool,
  isAdmin: PropTypes.bool,
  isExternalUser: PropTypes.bool,
  isFindingEditable: PropTypes.bool,
  isInternalResourceEditorUser: PropTypes.bool,
  jobContext: PropTypes.object,
  refetchCapHistories: PropTypes.func,
  removeResourceFromList: PropTypes.func,
  resource: PropTypes.objectOf(CapActionResourceModel),
  setResourceCache: PropTypes.func,
};

export const CapActionResourceDefaultPropTypes = {
  refetchCapHistories: noop
};

